var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import * as classnames from "classnames";
import * as uuidV4 from "uuid/v4";
import Pane from "../Pane";
var renderActivePane = function (children, fullWidth, id) {
    var paneProps = fullWidth ? { transparent: true } : { padding: true };
    return (React.createElement("div", { className: "wds-tab__panes", "labelled-by": id },
        React.createElement(Pane, __assign({}, paneProps), children)));
};
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (_a, value, id) {
            if (value !== _this.state.value) {
                _this.setState({ value: value });
                if (_this.props.onChange) {
                    _this.props.onChange(value, id);
                }
            }
        };
        var selectedIndex = _this.getSelectedIndex();
        _this.state = { value: selectedIndex || 0 };
        return _this;
    }
    // this is triggered when react router path change
    Tabs.prototype.componentDidUpdate = function (_prevProps, prevState) {
        var selectedIndex = this.getSelectedIndex();
        if (selectedIndex != prevState.value) {
            this.setState({ value: selectedIndex || 0 });
        }
    };
    Tabs.prototype.getSelectedIndex = function () {
        return React.Children.map(this.props.children, function (child, index) {
            var props = child.props;
            if (!React.isValidElement(child)) {
                return null;
            }
            if (props.selected) {
                return index;
            }
            return null;
        })[0];
    };
    Tabs.prototype.getClassNames = function () {
        var _a = this.props, color = _a.color, align = _a.align;
        return classnames("wds-tab", "wds-tab--" + color, "wds-tab--" + align);
    };
    Tabs.prototype.renderTabElement = function (child, index, selected, id) {
        return React.cloneElement(child, {
            selected: selected,
            onChange: this.handleChange,
            value: index,
            children: child.props.title,
            id: id,
            key: id
        });
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, children = _a.children;
        var TabList = [];
        var ActivePane = null;
        React.Children.forEach(children, function (child, index) {
            var props = child.props;
            if (React.isValidElement(child)) {
                var id = props.id || "tab-" + index + "-" + uuidV4();
                var selected = index === _this.state.value;
                TabList.push(_this.renderTabElement(child, index, selected, id));
                if (selected && props.children) {
                    ActivePane = renderActivePane(props.children, fullWidth, id);
                }
            }
        });
        return (React.createElement("div", { className: this.getClassNames() },
            React.createElement("ul", { role: "tablist", className: "wds-tab__tabs" }, TabList),
            ActivePane));
    };
    Tabs.defaultProps = {
        align: "left",
        fullWidth: false,
        onChange: null,
        color: "light"
    };
    return Tabs;
}(React.Component));
export default Tabs;
//# sourceMappingURL=Tabs.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@sm/smapply-ui/dist/es/components/Tabs/Tabs.js
// module id = 1813
// module chunks = 17